<template>
    <div
        v-if="items.length > 0"
        class="legend-footer"
    >
        <div class="legend-title">
            <span>{{ title }}</span>
        </div>
        <div class="legend-items">
            <div
                v-for="item in items"
                :key="item.id || item.name"
                class="legend-item"
            >
                <span
                    class="legend-color-box"
                    :style="{ backgroundColor: item.color }"
                />
                <span class="legend-label">{{ item.name }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'LegendFooter' });

interface LegendItem {
    id?: string | number;
    name: string;
    color: string;
}

interface Props {
    items: LegendItem[];
    title?: string;
}

withDefaults(defineProps<Props>(), { title: 'Legend:' });
</script>

<style scoped>
.legend-footer {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    /* background-color: #f8f9fa; */
    border-top: 1px solid #dee2e6;
    border-radius: 0 0 4px 4px;
}

.legend-title {
    font-weight: 600;
    font-size: 14px;
    color: #495057;
    white-space: nowrap;
    padding-top: 2px;
}

.legend-items {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    flex: 1;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #495057;
}

.legend-color-box {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    flex-shrink: 0;
    display: inline-block;
}

.legend-label {
    white-space: nowrap;
}
</style>
